export default {
  "cat.shoes": "Schuhe",
  "cat.hoodies": "Hoodies / Sweatshirts",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jacken",
  "cat.pants": "Hosen / Shorts",
  "cat.headwear": "Kopfbedeckungen",
  "cat.sets": "Sets",
  "cat.underwear": "Unterwäsche",
  "cat.jersey": "Trikots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Taschen",
  "cat.belts": "Gürtel",
  "cat.perfumes": "Parfums",
  "cat.other": "Sonstiges",
};